export enum EventTypes {
  CommodityRefresh = 'CommodityRefresh',
}
